import { getToken } from '@/utils/auth'
import { randomStr } from '@/utils/encrypt'
const deviceHeader = 'UNIQUE_ENV_ID'

export function getAuthHeader() {
  return 'Bearer ' + getToken()
}


export function getDeviceHeader() {
  if(getLocalStorageVal(deviceHeader)) {
    return getLocalStorageVal(deviceHeader)
  }

  let env_id = randomStr(32)
  setLocalStorageKeyVal(deviceHeader, env_id)

  return env_id
}

export function setLocalStorageKeyVal(key, val) {
  return localStorage.setItem(key, val)
}

export function getLocalStorageVal(key) {
  return localStorage.getItem(key)
}

export function removeLocalStorageVal(key) {
  return localStorage.removeItem(key)
}
